import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { ModalState } from './types'

import state from './state'
import getters from './getters'
import mutations from './mutations'

const module: Module<ModalState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
}

export default module
